var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right_content"},[_c('div',{staticClass:"p-title"},[_vm._v(_vm._s(_vm.title || '标题'))]),_c('div',{staticClass:"p-main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }